import React from "react";
import PropTypes from "prop-types";
import { Map } from "immutable";
import { Select, Tag, Icon, Modal, Button } from "antd";
import Input from "antd/lib/input";
import Row from "antd/lib/row";
import Col from "antd/lib/col";
import TableFiltersForm from "forms/table-filters-form";
// import _isEqual from "lodash/isEqual";s

const SelectOption = Select.Option;
const InputGroup = Input.Group;

class TableFilters extends React.Component {
    state = {
        open: false,
        modalVisible: false,
        selectValues: []
    };

    static getDerivedStateFromProps(props, state) {
        return {
            ...state,
            selectValues: [
                ...Object.keys(
                    new Map(props.filters).filter(_ => _ && _[0]).toJS()
                )
            ]
        };
    }
    clearFilter = key => {
        this.setState(
            {
                selectValues: this.state.selectValues.filter(_ => _ !== key),
                filters: { ...this.state.filters, [key]: [] }
            },
            () => this.onApply()
        );
    };

    getFilterValue(key) {
        const value = this.props.filters[key]
            ? this.props.filters[key][0]
            : null;
        if(typeof value === "object" && value && value.length) {
            return (
                <Tag color="#f50">
                    {value.join(", ")}
                </Tag>
            );
        }
        if (typeof value === "object" && value) {
            return (
                <Tag color="#f50">
                    {value.min && value.min._isAMomentObject
                        ? value.min.format("DD/MM/YYYY")
                        : value.min}{" "}
                    -{" "}
                    {value.max && value.max._isAMomentObject
                        ? value.max.format("DD/MM/YYYY")
                        : value.max}
                </Tag>
            );
        }
        return <Tag color={"#f50"}>{value}</Tag>;
    }

    onTagDeSelect = value => {
        this.props.applyFilters({ ...this.props.filters, [value]: [] });
    };

    updateFilters = values => {
        const filters = new Map(values)
            .filter(_ => !!_)
            .map(_ => {
                if(_ && _.length && typeof _ === "object" && typeof _[0] === "string") {
                    return [_];
                }
                if (_ && _.length && typeof _ === "object") {
                    return [
                        {
                            min: _[0],
                            max: _[1]
                        }
                    ];
                }
                return [_];
            });
        this.props.applyFilters({ ...this.props.filters, ...filters.toJS() });
        this.setState({
            modalVisible: false
        });
    };
    renderModal() {
        return (
            <Modal
                visible={this.state.modalVisible}
                width={"800px"}
                closable
                footer={null}
                // onOk={this.toggleModal}
                onCancel={this.toggleModal}>
                <TableFiltersForm
                    ref={node => (this.modalForm = node)}
                    columns={this.props.columns}
                    submit={this.updateFilters}
                    values={new Map(this.props.filters).map(_ => {
                        if (_ && typeof _[0] === "string") {
                            return _[0];
                        }
                        if (_ && typeof _ === "object" && _.length) {
                            return [_[0].min, _[0].max];
                        }
                        return _ && _[0];
                    })}
                />
            </Modal>
        );
    }
    onSearchString = str => {
        this.searchString = str;
        // this.setState({
        //     isSearchStringEditing: true,
        //     filters: { ...this.state.filters, ["search"]: [str] },
        //     selectValues: this.state.selectValues.find(_ => _ === "search")
        //         ? this.state.selectValues
        //         : [...this.state.selectValues, "search"]
        // });
    };
    onPressEnter = e => {
        if (e.keyCode === 13) {
            this.select.blur();
        }
    };
    onBlur = () => {
        this.props.applyFilters({
            ...this.props.filters,
            search: this.searchString
                ? [this.searchString]
                : this.props.filters.search
        });
        this.searchString = "";
    };
    onClear = () => {
        this.props.applyFilters({
            ...new Map(this.props.filters).map(() => []).toJS()
        });
    };
    render() {
        const { columns, hideColumnFiltersModal} = this.props;
        return (
            <div className={"d-flex align-items-center"}>
                {this.renderModal()}
                <InputGroup>
                    <Row>
                        
                        <Col span={22}>
                            <Select
                                className={"mr-5"}
                                allowClear
                                autoClearSearchValue
                                style={{ width: "100%" }}
                                mode={"multiple"}
                                value={this.state.selectValues}
                                placeholder={"Filters"}
                                onDeselect={this.onTagDeSelect}
                                optionLabelProp={"title"}
                                open={false}
                                onSearch={this.onSearchString}
                                onBlur={this.onBlur}
                                onInputKeyDown={this.onPressEnter}
                                ref={node => (this.select = node)}
                                clearIcon={
                                    <Icon
                                        type={"close-circle"}
                                        onClick={this.onClear}
                                    />
                                }>
                                {columns
                                    // .filter(_ => _.filterDropdown)
                                    .map(_ => (
                                        <SelectOption
                                            key={_.searchKey || _.key}
                                            value={_.searchKey || _.key}
                                            title={[
                                                <React.Fragment key="1">
                                                    {_.title} :{" "}
                                                    {this.getFilterValue(_.searchKey || _.key)}
                                                </React.Fragment>
                                            ]}
                                            className="d-flex justify-content-space-between align-items-center">
                                            {_.title}
                                        </SelectOption>
                                    ))
                                    .toList()
                                    .toArray()}
                                <SelectOption
                                    key={"search"}
                                    value={"search"}
                                    title={[
                                        <React.Fragment key="1">
                                            Search : {this.getFilterValue("search")}
                                        </React.Fragment>
                                    ]}
                                    className="d-flex justify-content-space-between align-items-center">
                                    Search
                                </SelectOption>
                            </Select>
                        </Col>
                        <Col span={2}>
                            {!hideColumnFiltersModal && <Button  onClick={this.toggleModal}>
                                <Icon type={"filter"} />
                            </Button>}
                        </Col>
                    </Row>
                </InputGroup>
                
                {/* <div className={"w-100 mr-5"}>
                    
                </div> */}
            </div>
        );
    }
    toggleModal = () => {
        this.setState({
            modalVisible: !this.state.modalVisible
        });
    };
}

TableFilters.propTypes = {
    columns: PropTypes.object, //Immutable Ordered Map
    applyFilters: PropTypes.func,
    filters: PropTypes.object,
    hideColumnFiltersModal : PropTypes.bool
};

export default TableFilters;
